



























































































































































































































































































































































import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
} from '@vue/composition-api';

import Pagination from '@/components/Pagination';
import Form from '@/components/Form/index.vue';
import cardTem from '@components/CardModel/index';
import titleBox from '@/components/Box/index.vue';
import * as echarts from 'echarts';
import request from '@utils/request';
import { isCore } from '@/useable/login';
import _Const from '@/Const';
import addComma from '@/utils/addComma';

export default defineComponent({
  name: 'Supplier',
  components: {
    Form,
    cardTem,
    titleBox,
    Pagination,
  },
  setup() {
    // const option1 = {
    //   color:['#3A84FB', '#F0F6FF'],
    //   title:{
    //     text:'',
    //     left:'center',
    //     top:'50%',
    //     textStyle:{
    //       color:'#FF5C5C',
    //       fontSize:16,
    //       align:'center'
    //     }
    //   },
    //   graphic:{
    //     type:'text',
    //     left:'center',
    //     top:'40%',
    //     style:{
    //       text:'已用',
    //       textAlign:'center',
    //       fill:'#333',
    //       fontSize:16,
    //       fontWeight:700
    //     }
    //   },
    //   series: [
    //     {
    //       name: '已用额度',
    //       type: 'pie',
    //       radius: ['50%', '70%'],
    //       startAngle:180,
    //       avoidLabelOverlap: false,
    //       label: {
    //         show: false,
    //         position: 'center'
    //       },
    //       data: [
    //       ]
    //     }
    //   ]
    // };
    const option2 = {
      tooltip: {
        trigger: 'axis',
        formatter(params) {
          return `<span style='text-align:left;line-height:14px;float:left;'>${
            params[0].name
          }</span><br/><span style='text-align:left;line-height:14px;float:left;'>融资单数量:${
            params[0].value
          }(笔)</span><br/><span style='text-align:left;line-height:14px;float:left;'>融资金额:${putComma(
            params[1].value,
          )}(万元)</span>`;
        },
        backgroundColor: 'rgba(111,111,111,0.9)',
        borderColor: '#ccc',
        textStyle: {
          color: '#fff',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontFamily: 'sans-serif',
          fontSize: 14,
        },
      },
      calculable: true,
      legend: {
        top: '0%',
        left: '0%',
        data: ['融资单数量', '融资金额'],
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: '笔',
          nameTextStyle: {
            fontSize: 12,
            color: '#000',
            padding: [0, 25, 0, 0],
          },
        },
        {
          type: 'value',
          name: '万元',
          nameTextStyle: {
            fontSize: 12,
            color: '#000',
            padding: [0, 0, 0, 25],
          },
        },
      ],
      grid: {
        left: '40',
        top: '30%',
        right: '100',
        bottom: '10%',
      },
      series: [
        {
          name: '融资单数量',
          type: 'line',
          yAxisIndex: 0,
          symbol: 'circle',
          symbolSize: 8,
          data: [],
          itemStyle: {
            normal: {
              color: '#FFAC15',
              lineStyle: {
                color: '#FFAC15',
              },
            },
          },
        },
        {
          name: '融资金额',
          type: 'bar',
          smooth: true,
          yAxisIndex: 1,
          data: [],
          barWidth: 12,
          itemStyle: {
            color: '#3A84FB',
            borderRadius: [6, 6, 6, 6],
          },
        },
      ],
    };
    const option3 = {
      tooltip: {
        trigger: 'axis',
        formatter(params) {
          return `<span style='text-align:left;line-height:14px;float:left;'>${params[0].name}</span><br/><span style='text-align:left;line-height:14px;float:left;'>融资单数量:${params[0].value}(万元)</span>`;
        },
        backgroundColor: 'rgba(111,111,111,0.9)',
        borderColor: '#ccc',
        textStyle: {
          color: '#fff',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontFamily: 'sans-serif',
          fontSize: 14,
        },
      },
      legend: {
        top: -4,
        left: 'left',
        data: ['应收金额'],
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: '万元',
          nameTextStyle: {
            fontSize: 12,
            color: '#000',
            padding: [0, 25, 0, 0],
          },
        },
      ],
      grid: {
        left: '60',
        top: '15%',
        right: '0',
        bottom: '10%',
      },
      series: [
        {
          name: '融资金额',
          type: 'bar',
          smooth: true,
          yAxisIndex: 0,
          data: [],
          barWidth: 12,
          itemStyle: {
            color: '#3A84FB',
            borderRadius: [6, 6, 6, 6],
          },
        },
      ],
    };
    const optionBankFinancing = {
      tooltip: {
        trigger: 'item',
        formatter: (param) => {
          return `${param.name}\n${addComma(param.value)}\n${param.percent}%`;
        },
      },
      series: [
        {
          type: 'pie',
          radius: '50%',
          label: {
            show: true,
            fontSize: 12,
            lineHeight: 12,
            formatter: (param) => {
              return `${param.name}\n${addComma(param.value)}\n${
                param.percent
              }%`;
            },
            // formatter: '{b}\n{c}\n{d}%',
            // rich: {
            //   percent: {
            //     color: '#FF5C5C',
            //   },
            // },
          },
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };

    const nameToColor = {
      CMB: '#006ae4',
      CCB: '#00c4d1',
      PINGAN: '#63ce68',
      BCM: '#ff5c5c',
      ICBC: '#ffac15',
      SPD: '#56a5ff',
      BOC: '#699aff',
    };

    const tableConfigBankFinancing = ref({
      column: [
        { key: 'bankName', label: '银行名称', width: 120 },
        {
          key: 'bankMonthTotalAmount',
          amount: true,
          sortable: true,
          label: '当月融资金额',
          width: 200
        },
        {
          key: 'bankMonthPerc',
          label: '当月融资占比',
          custom: true,
          width: 110,
        },
        {
          key: 'bankYearTotalAmount',
          amount: true,
          sortable: true,
          label: '全年融资金额',
          width: 200
        },
        {
          key: 'bankYearPerc',
          label: '全年融资占比',
          custom: true,
          width: 110,
        },
        {
          key: 'bankTotalAmount',
          amount: true,
          sortable: true,
          label: '累计融资金额',
          width: 200
        },
        {
          key: 'bankTotalPerc',
          label: '累计融资占比',
          custom: true,
          width: 110,
        },
      ],
      data: [],
    });

    const state: any = reactive({
      bankContainer1: null,
      bankContainer2: null,
      bankContainer3: null,
      bankFinDetailVO: [],
      loginstatus: false,
      bankTab: 0,
      form: {
        bankName: '',
        supplierName: '',
        statisticalMonth: `${new Date().getFullYear()}-${
          new Date().getMonth() + 1
        }`,
      },
      supplierForm: {
        statisticalMonth: `${new Date().getFullYear()}-${
          new Date().getMonth() + 1
        }`,
      },
      companyData: [
        {
          title: '融资中供应商情况 ：',
          num: 0,
          introduce: '',
          cardstyle: 'money',
        },
        {
          title: '当月供应商融资情况 ：',
          num: 0,
          introduce: '',
          cardstyle: 'money',
        },
        {
          title: '全年供应商融资情况 ：',
          num: 0,
          introduce: '',
          cardstyle: 'money',
        },
        {
          title: '累计供应商融资情况 ：',
          num: 0,
          introduce: '',
          cardstyle: 'money',
        },
        {
          title: '融资余额 ：',
          num: 0,
          introduce: '',
          cardstyle: 'money',
        },
      ],
      supplierData1: [
        { title: '当月融资情况 ：', num: 0, introduce: '', cardstyle: 'home' },
        {
          title: '当月融资成本 ：',
          num: 0,
          cardstyle: 'home',
          Mtop: 24,
          tipInfo: '根据本系统中记录的用户申请融资的数据计算',
        },
        { title: '全年融资情况 ：', num: 0, introduce: '', cardstyle: 'money' },
        {
          title: '全年融资成本 ：',
          num: 0,
          cardstyle: 'money',
          Mtop: 24,
          tipInfo: '根据本系统中记录的用户申请融资的数据计算',
        },
      ],
      orderNo: '',
      payCorpName: '',
      applyAmount: '0',
      loanDate: '',
      planPayTime: '',

      availableQuota: 0,
      availableQuotaNum: '0',

      totalAmount: 0,
      totalAmountNum: '0',
      usedQuota: '0',

      alreadyApplied: 0,

      Loaned: 0,
      underReview: 0,
      lastFinancing: '',

      supplierData2: [
        {
          title: '当月应收额 ：',
          num: 0,
          cardstyle: 'money',
          Mtop: 24,
          tipInfo: '仅统计注册平台后产生的付款单',
        },
        {
          title: '累计未开票金额 ：',
          num: 0,
          cardstyle: 'money',
          Mtop: 24,
          tipInfo: '仅统计注册平台后产生的付款单',
        },
        {
          title: '全年发生额 ：',
          num: 0,
          cardstyle: 'money',
          Mtop: 24,
          tipInfo: '仅统计注册平台后产生的付款单',
        },
      ],
      formSupplierColumn: [
        {
          name: 'bankName',
          type: 'select',
          label: '银行名称：',
          placeholder: '请选择',
          options: [],
        },
        {
          name: 'supplierName',
          type: 'input',
          label: '供应商名称：',
          placeholder: '输入供应商名称',
          options: [],
        },
        {
          name: 'statisticalMonth',
          type: 'month',
          label: '统计月份：',
          noClear: true,
          placeholder: '',
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          },
        },
      ],
      coreBusinessColumn: [
        {
          name: 'statisticalMonth',
          type: 'month',
          label: '统计月份:',
          placeholder: '',
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          },
        },
      ],
      formBusinessColumn: [
        {
          name: 'companyName',
          type: 'input',
          label: '供应商名称：',
          disabled: true,
          placeholder: '',
        },
        {
          name: 'paymentSlipStatus',
          type: 'select',
          label: '付款单状态：',
          placeholder: '',
          options: [
            {
              name: '全部',
              value: '5',
            },
            {
              name: '付款单提交',
              value: '0',
            },
            {
              name: '发票已签收',
              value: '1',
            },
            {
              name: '发票审核',
              value: '2',
            },
            {
              name: '推送付款',
              value: '3',
            },
            {
              name: '已收款',
              value: '4',
            },
          ],
        },
        {
          name: 'paymentSlipNumber',
          type: 'input',
          label: '付款单号：',
          placeholder: '输入结算单号',
          options: [],
        },
      ],
    });
    const onSearch = (val) => {
      state.form = val;
      state.page = 1;
    };
    const supplierInit = (data) => {
      // echarts.dispose(document.getElementById('bankContainer') as HTMLDivElement);
      echarts.dispose(
        document.getElementById('amountContainer') as HTMLDivElement,
      );
      echarts.dispose(
        document.getElementById('receiveContainer') as HTMLDivElement,
      );
      // const bankChart = echarts.init(document.getElementById('bankContainer') as HTMLDivElement);
      const amountChart = echarts.init(
        document.getElementById('amountContainer') as HTMLDivElement,
      );
      const receiveChart = echarts.init(
        document.getElementById('receiveContainer') as HTMLDivElement,
      );
      // bankChart.setOption(option1);
      const list: any = [];
      for (let i = 1; i <= 12; i++) {
        list.push(`${data.split('-')[0]}-${i}月`);
      }
      option2.xAxis[0].data = list;
      option3.xAxis[0].data = list;
      amountChart.setOption(option2);
      receiveChart.setOption(option3);
    };
    const coreBusinessInit = (data) => {
      // echarts.dispose(document.getElementById('bankContainer') as HTMLDivElement);
      echarts.dispose(
        document.getElementById('amountContainer') as HTMLDivElement,
      );

      // const bankChart = echarts.init(document.getElementById('bankContainer') as HTMLDivElement);
      const amountChart = echarts.init(
        document.getElementById('amountContainer') as HTMLDivElement,
      );

      // bankChart.setOption(option1);
      const list: any = [];
      for (let i = 1; i <= 12; i++) {
        list.push(`${data.split('-')[0]}-${i}月`);
      }
      option2.xAxis[0].data = list;
      amountChart.setOption(option2);
    };
    const supplierSearch = (val) => {
      const date = getDate(val);
      getSupDataStatistics(date);
    };
    const companySearch = (val) => {
      const date = getDate(val);
      getCorDataStatistics(date);
    };
    const putComma = (val) => {
      if (!val) {
        return '0';
      }
      const str = val.toString();
      const reg =
        str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, '$1,');
    };
    const getBankList = async () => {
      const res = await request('bill', 'getBankList', {});
      if (res.code === 2000) {
        if (res.data.length > 0) {
          res.data.forEach((item) => {
            item.name = item.bankName;
            item.value = item.bankCode;
          });
          state.formSupplierColumn[0].options = res.data;
        }
      }
    };
    const getCorDataStatistics = async (data) => {
      const res = await request('bill', 'getCorDataStatistics', {
        date: data,
        supplierName: state.form.supplierName ? state.form.supplierName : '',
        bankCode: state.form.bankName,
      });
      if (res.code === 2000) {
        const result = res.data;
        state.companyData[0].introduce = `${result.corFinancingAttachInfoVo.inFinancingInfoSum}家,${result.corFinancingAttachInfoVo.inFinancingInfoCount}笔`;
        state.companyData[0].num = `${putComma(
          result.corFinancingAttachInfoVo.inFinancingInfoTotalAmount,
        )}元`;
        state.companyData[1].introduce = `${result.corFinancingAttachInfoVo.nowMonthSupFinancingInfoSum}家,${result.corFinancingAttachInfoVo.nowMonthSupFinancingInfoCount}笔`;
        state.companyData[1].num = `${putComma(
          result.corFinancingAttachInfoVo.nowMonthSupFinancingInfoTotalAmount,
        )}元`;
        state.companyData[2].introduce = `${result.corFinancingAttachInfoVo.nowYearSupFinancingInfoSum}家,${result.corFinancingAttachInfoVo.nowYearSupFinancingInfoCount}笔`;
        state.companyData[2].num = `${putComma(
          result.corFinancingAttachInfoVo.nowYearSupFinancingInfoTotalAmount,
        )}元`;
        state.companyData[3].introduce = `${result.corFinancingAttachInfoVo.totalFinancingsupplier}家,${result.corFinancingAttachInfoVo.totalFinancingCount}笔`;
        state.companyData[3].num = `${putComma(
          result.corFinancingAttachInfoVo.totalFinancingAmount,
        )}元`;
        // 融资余额数据绑定
        state.companyData[4].introduce = `${result.corFinancingAttachInfoVo.balanceSums || 0}家,${result.corFinancingAttachInfoVo.balanceCounts || 0}笔`;
        state.companyData[4].num = `${putComma(
          result.corFinancingAttachInfoVo.balanceAmount || 0,
        )}元`;

        if (result.bankAvailableCreditInfoVo) {
          state.availableQuota =
            result.bankAvailableCreditInfoVo.bankAvailableCredit;
          state.availableQuotaNum = putComma(
            result.bankAvailableCreditInfoVo.bankAvailableCredit,
          );
          state.totalAmount = result.bankAvailableCreditInfoVo.totalAmount;
          state.totalAmountNum = putComma(
            result.bankAvailableCreditInfoVo.totalAmount,
          );
          state.usedQuota = putComma(result.bankAvailableCreditInfoVo.used);
        }

        const usedQuotaList: any = [];
        usedQuotaList.push(state.availableQuota);
        usedQuotaList.push(state.totalAmount);
        // option1.series[0].data = usedQuotaList;
        // option1.title.text = state.totalAmount>0?`${((state.availableQuota/state.totalAmount)*100).toFixed(2)}%`:'0%';
        if (result.supFinancingInfoVo) {
          state.alreadyApplied = result.supFinancingInfoVo.appliedSum;
          state.Loaned = result.supFinancingInfoVo.loanSum;
          state.underReview = result.supFinancingInfoVo.examineAndVerifySum;
          state.orderNo = result.supFinancingInfoVo.orderNo;
          state.payCorpName = result.supFinancingInfoVo.payCorpName;
          state.applyAmount = putComma(result.supFinancingInfoVo.applyAmount);
          state.loanDate = result.supFinancingInfoVo.loanDate;
          state.planPayTime = result.supFinancingInfoVo.planPayTime;
          state.lastFinancing = result.supFinancingInfoVo.supplierName;
        }
        const financingBillNum: any = [];
        const financingAmount: any = [];
        if (result.chart && result.chart.length > 0) {
          result.chart.forEach((item) => {
            financingBillNum.push(item.financingOrderCount);
          });
          result.chart.forEach((item) => {
            financingAmount.push((Number(item.totalAmount) / 10000).toFixed(6));
          });
        }
        option2.series[0].data = financingBillNum;
        option2.series[1].data = financingAmount;
        state.bankFinDetailVO = result.bankFinDetailVO;
        // 无论当前在哪个Tab，都更新表格数据
        tableConfigBankFinancing.value.data = state.bankFinDetailVO.map((i) => ({
          ...i,
          bankName: _Const.BankCodeToName[i.bankCode],
          bankMonthTotalAmount: Number(i.bankMonthTotalAmount),
          bankYearTotalAmount: Number(i.bankYearTotalAmount),
          bankTotalAmount: Number(i.bankTotalAmount),
        }));
        // 图表Tab时额外初始化图表
        if (state.bankTab === 0) {
          initBankGraph();
        }

        coreBusinessInit(data);
      }
    };
    const initBankGraph = () => {
      let showBank1 = true;
      let showBank2 = true;
      let showBank3 = true;
      state.bankFinDetailVO.forEach((i) => {
        showBank1 = i.bankMonthTotalAmount > 0 ? false : showBank1;
        showBank2 = i.bankYearTotalAmount > 0 ? false : showBank2;
        showBank3 = i.bankTotalAmount > 0 ? false : showBank3;
      });
      const bankList1 = state.bankFinDetailVO.map((i) => ({
        name: _Const.BankCodeToName[i.bankCode],
        value: i.bankMonthTotalAmount,
        label: { show: i.bankMonthTotalAmount > 0 || showBank1 },
        itemStyle: { color: nameToColor[i.bankCode] },
      }));
      const bankList2 = state.bankFinDetailVO.map((i) => ({
        name: _Const.BankCodeToName[i.bankCode],
        value: i.bankYearTotalAmount,
        label: { show: i.bankYearTotalAmount > 0 || showBank2 },
        itemStyle: { color: nameToColor[i.bankCode] },
      }));
      const bankList3 = state.bankFinDetailVO.map((i) => ({
        name: _Const.BankCodeToName[i.bankCode],
        value: i.bankTotalAmount,
        itemStyle: { color: nameToColor[i.bankCode] },
      }));
      tableConfigBankFinancing.value.data = state.bankFinDetailVO.map((i) => ({
        ...i,
        bankName: _Const.BankCodeToName[i.bankCode],
        bankMonthTotalAmount: Number(i.bankMonthTotalAmount),
        bankYearTotalAmount: Number(i.bankYearTotalAmount),
        bankTotalAmount: Number(i.bankTotalAmount),
      }));

      echarts.dispose(
        document.getElementById('bankContainer1') as HTMLDivElement,
      );
      echarts.dispose(
        document.getElementById('bankContainer2') as HTMLDivElement,
      );
      echarts.dispose(
        document.getElementById('bankContainer3') as HTMLDivElement,
      );
      state.bankContainer1 = echarts.init(
        document.getElementById('bankContainer1') as HTMLDivElement,
      );
      state.bankContainer2 = echarts.init(
        document.getElementById('bankContainer2') as HTMLDivElement,
      );
      state.bankContainer3 = echarts.init(
        document.getElementById('bankContainer3') as HTMLDivElement,
      );
      state.bankContainer1.setOption({
        ...optionBankFinancing,
        series: [{ ...optionBankFinancing.series[0], data: bankList1 }],
      });
      state.bankContainer2.setOption({
        ...optionBankFinancing,
        series: [{ ...optionBankFinancing.series[0], data: bankList2 }],
      });
      state.bankContainer3.setOption({
        ...optionBankFinancing,
        series: [{ ...optionBankFinancing.series[0], data: bankList3 }],
      });
    };
    const getSupDataStatistics = async (data) => {
      const res = await request('bill', 'getSupDataStatistics', {
        date: data,
      });
      if (res.code === 2000) {
        const result = res.data;
        state.supplierData1[0].num = `${putComma(
          result.nowMonthSupFinancingInfoTotalAmount,
        )}元`;
        state.supplierData1[0].introduce = `${result.nowMonthSupFinancingInfoCount}笔`;
        state.supplierData1[1].num = `${putComma(
          result.nowMonthFinancingCost,
        )}元`;
        state.supplierData1[2].num = `${putComma(
          result.nowYearSupFinancingInfoTotalAmount,
        )}元`;
        state.supplierData1[2].introduce = `${result.nowYearSupFinancingInfoCount}笔`;
        state.supplierData1[3].num = `${putComma(
          result.nowYearFinancingCost,
        )}元`;

        if (result.bankAvailableCreditInfoVo) {
          state.availableQuota =
            result.bankAvailableCreditInfoVo.bankAvailableCredit;
          state.availableQuotaNum = putComma(
            result.bankAvailableCreditInfoVo.bankAvailableCredit,
          );
          state.totalAmount = result.bankAvailableCreditInfoVo.totalAmount;
          state.totalAmountNum = putComma(
            result.bankAvailableCreditInfoVo.totalAmount,
          );
          state.usedQuota = putComma(result.bankAvailableCreditInfoVo.used);
        }

        const usedQuotaList: any = [];
        usedQuotaList.push(state.availableQuota);
        usedQuotaList.push(state.totalAmount);
        // option1.series[0].data = usedQuotaList;
        // option1.title.text = state.totalAmount>0?`${((state.availableQuota/state.totalAmount)*100).toFixed(2)}%`:'0%';
        if (result.supFinancingInfoVo) {
          state.orderNo = result.supFinancingInfoVo.orderNo;
          state.payCorpName = result.supFinancingInfoVo.payCorpName;
          state.applyAmount = putComma(result.supFinancingInfoVo.applyAmount);
          state.loanDate = result.supFinancingInfoVo.loanDate;
          state.planPayTime = result.supFinancingInfoVo.planPayTime;
        }
        const financingBillNum: any = [];
        const financingAmount: any = [];
        const amountReceivable: any = [];
        result.msftachart.forEach((item) => {
          financingBillNum.push(item.financingOrderCount);
        });
        result.msftachart.forEach((item) => {
          financingAmount.push((Number(item.totalAmount) / 10000).toFixed(6));
        });
        result.mrachart.forEach((item) => {
          amountReceivable.push(
            (Number(item.receivableAmount) / 10000).toFixed(6),
          );
        });
        option2.series[0].data = financingBillNum;
        option2.series[1].data = financingAmount;
        option3.series[0].data = amountReceivable;
        state.supplierData2[0].num = `${putComma(
          result.nowMonthreceivableAmount,
        )}元`;
        state.supplierData2[1].num = `${putComma(result.unbilledCumulative)}元`;
        state.supplierData2[2].num = `${putComma(result.nowYearPeriodTotal)}元`;
        supplierInit(data);
      }
    };
    const getDate = (date) => {
      let yearMonth: any = '';
      if (typeof date.statisticalMonth === 'object') {
        const y = date.statisticalMonth.getFullYear();
        let m = date.statisticalMonth.getMonth() + 1;
        m = m < 10 ? `0${m}` : m;
        yearMonth = `${y}-${m}`;
      } else {
        const [y, m] = date.statisticalMonth.split('-');
        yearMonth = `${y}-${Number(m) < 10 ? `0${m}` : m}`;
      }
      return yearMonth;
    };

    const toggleTab = (type) => {
      state.bankTab = type;
      if (type === 0) {
        nextTick(() => {
          initBankGraph();
        });
      }
    };

    if (isCore.value) {
      state.loginstatus = true;
      getBankList();
      getCorDataStatistics(state.supplierForm.statisticalMonth);
    } else {
      getSupDataStatistics(state.supplierForm.statisticalMonth);
      state.loginstatus = false;
    }
    return {
      ...toRefs(state),
      onSearch,
      supplierSearch,
      companySearch,
      tableConfigBankFinancing,
      toggleTab,
    };
  },
});
